import Svg, { Circle, ClipPath, Defs, Ellipse, G, Path, Rect } from 'react-native-svg'

export const InvalidCardIcon = ({ height, width, color = '#ffd9d8' }: { height: any; width: any; color?: any }) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 32 32" accessible={false} tabIndex={-1}>
      <Defs>
        <ClipPath id="clip-Invslid_Front">
          <Rect width="32" height="32" accessible={false} tabIndex={-1} />
        </ClipPath>
      </Defs>
      <G
        id="Invslid_Front"
        data-name="Invslid Front"
        clipPath="url(#clip-Invslid_Front)"
        accessible={false}
        tabIndex={-1}>
        <G id="Group_3" data-name="Group 3" transform="translate(-805 -387)" accessible={false} tabIndex={-1}>
          <Rect
            id="Rectangle_857"
            data-name="Rectangle 857"
            width="24"
            height="16"
            rx="2"
            transform="translate(809 395)"
            fill={color}
            accessible={false}
            tabIndex={-1}
          />
          <G id="Group_1" data-name="Group 1" accessible={false} tabIndex={-1}>
            <Ellipse
              id="Ellipse_2"
              data-name="Ellipse 2"
              cx="2"
              cy="2"
              r="2"
              transform="translate(812 398)"
              fill="#fff"
              accessible={false}
              tabIndex={-1}
            />
            <Rect
              id="Rectangle_862"
              data-name="Rectangle 862"
              width="4"
              height="1"
              transform="translate(812 406)"
              fill="#fff"
              accessible={false}
              tabIndex={-1}
            />
            <Rect
              id="Rectangle_863"
              data-name="Rectangle 863"
              width="4"
              height="1"
              transform="translate(817 406)"
              fill="#fff"
              accessible={false}
              tabIndex={-1}
            />
            <Rect
              id="Rectangle_864"
              data-name="Rectangle 864"
              width="4"
              height="1"
              transform="translate(822 406)"
              fill="#fff"
              accessible={false}
              tabIndex={-1}
            />
            <Rect
              id="Rectangle_865"
              data-name="Rectangle 865"
              width="4"
              height="1"
              transform="translate(827 406)"
              fill="#fff"
              accessible={false}
              tabIndex={-1}
            />
          </G>
          <G id="Group_6" data-name="Group 6" transform="translate(-32)" accessible={false} tabIndex={-1}>
            <Circle
              id="Ellipse_1"
              data-name="Ellipse 1"
              cx="6.5"
              cy="6.5"
              r="6.5"
              transform="translate(855 399)"
              fill="#bc514d"
              accessible={false}
              tabIndex={-1}
            />
            <Path
              id="Path_269"
              data-name="Path 269"
              d="M5.116,2.472l-.192,3.8H4.076l-.192-3.8ZM4.5,6.664a.709.709,0,0,1,.36.092A.681.681,0,0,1,5.112,7a.672.672,0,0,1,.092.348.694.694,0,0,1-.092.352.644.644,0,0,1-.252.248.78.78,0,0,1-.72,0A.644.644,0,0,1,3.888,7.7.694.694,0,0,1,3.8,7.352.672.672,0,0,1,3.888,7a.681.681,0,0,1,.252-.248A.709.709,0,0,1,4.5,6.664Z"
              transform="translate(857 400)"
              fill="#fff"
              accessible={false}
              tabIndex={-1}
            />
          </G>
        </G>
      </G>
    </Svg>
  )
}
